import { createApp } from 'vue'
import { setupI18n, loadLocaleMessages } from './i18n.js'
import App from './App.vue'
import router from './router'

const i18n = setupI18n({ locale: 'en' });
loadLocaleMessages(i18n, 'en');

createApp(App).use(i18n).use(router).mount('#app')
